import React from "react";
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import useLogin from "@common/components/hooks/useLogin";
import LoadingAction from "@common/redux/actions/LoadingAction";

/**
 * FormButtonsComponent renders buttons for a form.
 *
 * @typedef {object} FormButtonsProps
 * @property {boolean} isValid - Boolean for if the form is valid.
 * @property {Function} resetForm - Function for handling resetting the form.
 *
 * @component
 * @param {FormButtonsProps} props - The component props.
 * @returns {JSX.Element} The rendered form buttons.
 */
export default function FormButtonsComponent({ isValid, resetForm }) {
  const [{ isDesktop, isInReadMode }] = useLogin();
  const { loading } = useSelector((state) => LoadingAction.getStatePath(state));

  if (isInReadMode) return <></>;

  return (
    <div className="py-1 flex-between">
      {!isDesktop && (
        <Button type="button" onClick={resetForm}>
          Reset
        </Button>
      )}
      <Button
        disabled={!isValid || isInReadMode || loading}
        type="submit"
        positive={true}
      >
        Save
      </Button>
    </div>
  );
}
